import AbilityCheckCategoryList from './competencyAssessment/abilityCheckCategory/abilityCheckCategoryList';
import AbilityCheckCategoryDetail from './competencyAssessment/abilityCheckCategory/abilityCheckCategoryDetail';
import AbilityCheckItemList from './competencyAssessment/abilityCheckItem/abilityCheckItemList';
import AbilityCheckItemDetail from './competencyAssessment/abilityCheckItem/abilityCheckItemDetail';
import StudentAbilityItemDetail from './competencyAssessment/studentAbilityItem/studentAbilityItemDetail';
import StudentAbilityList from './competencyAssessment/studentAbility/studentAbilityList';
import StudentAbilityFileImport from './competencyAssessment/studentAbility/studentAbilityFileImport';
import TrainPathList from './path/trainPath/trainPathList';
import TrainPathStage from './path/trainPathStage/trainPathStage';
import TrainPathDetail from './path/trainPath/trainPathDetail';
import TrainPathCommentList from './comment/commentList';
import TrainPathCommentDetail from './comment/commentEdit/commentEdit';
import trainPathStageScoreRule from './path/trainPathStageScoreRule/trainPathStageScoreRule';
import trainPathStageScoreRuleDetail from './path/trainPathStageScoreRule/detail';
import LookComment from "./comment/commentShow/lookComment";
import LookTrainPath from "./path/trainPathStage/lookTrainPath";
import StudentTrainPathList from "./path/trainPathStage/studentTrainPathList";
import CertDetail from "./cert/certDetail/certDetail";
import CertList from "./cert/certList";
import CertInfo from "./cert/certDetail/certInfo";
import PersonalCertList from "./personalCert/personalCertList";
import PersonalCertInfo from "./personalCert/personalCertDetail/personalCertInfo";
import CertApplyAuditDetail from "./certApply/certApplyAudit/certApplyAuditDetail";
import CertApplyList from "./certApply/certApplyList";
import PersonalCertIDetail from "./personalCert/personalCertDetail/personalCertIDetail";
import CertLinkList from "./certLink/certLinkList";
import CertImport from "./personalCert/certImport";
import CertLinkImport from "./certLink/certLinkImport";
import SubjectList from "./credit/subject/subjectList"
import SubjectDetail from "./credit/subject/subjectDetail";
import SubjectInfo from "./credit/subject/subjectInfo";
import SubjectCreditRecordList from "./credit/subjectcreditrecord/subjectCreditRecordList";
import StudentCommentAudit from "./comment/studentComment/studentCommentAudit";
import AuditComment from "./comment/studentComment/auditComment";
import RequirementList from "./requirement/requirementList";
import RequirementDetail from "./requirement/requirementDetail/requirementDetail";
import RequirementRecord from "./requirement/requirementRecord/requirementRecord";
import TrainPathFileImport from "./path/trainPath/trainPathFileImport";
import CertificateStatistics from "./certificateStatistics";
import CertificateStatisticsCfg from "./certificateStatisticsCfg";
import CertStageList from "./certStage/certStageList";
import RequirementPersonnelList from "./requirementPersonnel/requirementPersonnelList";
import RequirementPersonnelDetailList from "./requirementPersonnel/requirementPersonnelDetail/requirementPersonnelDetailList";
import RequirementPersonnelApplyList from './requirementPersonnel/apply/requirementPersonnelApplyList'
import RequirementConfigList from "./requirementConfig/requirementConfigList";
import RequirementConfigDetail from "./requirementConfig/requirementConfig/requirementConfigDetail";
import DealerNewPersonTrainList from "./dealerNewPersonTrain/dealerNewPersonTrainList";
import DealerNewPersonTrainDetailList from "./dealerNewPersonTrain/dealerNewPersonTrainDetail/dealerNewPersonTrainDetailList";
import RequirementPartTimePosition from "./requirementPartTimePosition/requirementPartTimePositionManager";
import RequirementPartTimePositionDetail from "./requirementPartTimePosition/requirementPartTimePositionDetail";

export {
  AbilityCheckCategoryList,
  AbilityCheckCategoryDetail,
  AbilityCheckItemList,
  AbilityCheckItemDetail,
  StudentAbilityItemDetail,
  StudentAbilityList,
  StudentAbilityFileImport,
  TrainPathList,
  TrainPathDetail,
  TrainPathCommentList,
  TrainPathCommentDetail,
  LookComment,
  TrainPathStage,
  LookTrainPath,
  StudentTrainPathList,
  CertDetail,
  CertList,
  CertInfo,
  PersonalCertList,
  PersonalCertInfo,
  CertApplyAuditDetail,
  CertApplyList,
  PersonalCertIDetail,
  CertLinkList,
  CertImport,
  CertLinkImport,
  SubjectList,
  SubjectDetail,
  SubjectInfo,
  SubjectCreditRecordList,
  StudentCommentAudit,
  AuditComment,
  RequirementList,
  RequirementDetail,
  RequirementRecord,
  TrainPathFileImport,
  CertificateStatistics,
  CertificateStatisticsCfg,
  CertStageList,
  RequirementPersonnelList,
  RequirementPersonnelDetailList,
  RequirementPersonnelApplyList,
  RequirementConfigList,
  RequirementConfigDetail,
  DealerNewPersonTrainList,
  DealerNewPersonTrainDetailList,
  RequirementPartTimePosition,
  RequirementPartTimePositionDetail,
  trainPathStageScoreRule,
  trainPathStageScoreRuleDetail
}
